export default {
  REPAIR: 'Repair',
  RECYCLE: 'Recycle',
  RETURN: 'Return'
};
